
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/seller-rental-agreement",
      function () {
        return require("private-next-pages/info/seller-rental-agreement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/seller-rental-agreement"])
      });
    }
  